var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"columns is-centered"},[_c('div',{staticClass:"column"},[_c('a',{attrs:{"href":_vm.url,"target":"_blank"}},[_vm._v("If the file does not automatically open, click here to open it.")])])])}
var staticRenderFns = []

export { render, staticRenderFns }